import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './styles.scss'
import { getTourOperators } from '../../../../http/driveApiGateway/client'
import PropTypes from 'prop-types'
import { Col, Container, Row } from '../../../Shared/Grid'
import TourOperatorsList from './list'
import Offer from './offer'
import Alert from '../../../Shared/Alert'
import PageHead from '../../../Shared/PageHead'
import GreyMainHotel from '../../../Shared/Hotel/GreyMainHotel'
import { constants } from '../../../../constants'

const TourOperators = ({ giataId, item, relatedItems, propertyImage }) => {
  const [selectedOffer, setSelectedOffer] = useState(null)
  const [tourOperators, setTourOperators] = useState(null)
  const [error, setError] = useState(false)
  const { t } = useTranslation()

  const onOfferSelected = useCallback((operator, offer) => {
    setSelectedOffer({ operator, offer })
  }, [])

  const onGoToListClick = useCallback(() => {
    setSelectedOffer(null)
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      setError(false)
      try {
        const data = await getTourOperators(giataId).fetchPromise
        setTourOperators(data)
      } catch (error) {
        setError(true)
      }
    }
    fetchData().catch(() => {})
  }, [giataId])

  if (!tourOperators) {
    return null
  }

  return (
    <div className="Page page-tour-operators">
      <div className="TourOperator">
        {error ? (
          <Alert type="danger">{t('DEFAULT_ERROR_MESSAGE')}</Alert>
        ) : (
          <>
            <Container fluid>
              <Row>
                <Col>
                  <PageHead
                    title={t('LABEL_TOUR_OPERATORS')}
                    subtitle="This page shows you a list of Tour Operators that offer your property."
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <span style={{ lineHeight: '37px' }}>
                    Those marked with “Push” receive content from GIATA Drive automatically. For your content to be updated across other TOs, you can send your Open Content Link or request that they access your content
                    from the GIATA Hotel Directory.
                  </span>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div style={{ marginTop: '50px', marginBottom: '24px' }}>
                    <GreyMainHotel
                      item={item}
                      relatedItems={relatedItems}
                      propertyImage={propertyImage}
                      infoValues={[
                        {
                          header: 'GIATA ID',
                          value: item.attr[constants.attributePaths.giataId][1].data.code
                        },
                        {
                          header: t('LABEL_TOUR_OPERATORS'),
                          value: tourOperators.operators
                        },
                        {
                          header: t('LABEL_OFFERS'),
                          value: tourOperators.offers
                        },
                      ]}
                    />
                  </div>
                </Col>
              </Row>
            </Container>
            {selectedOffer ?
              <Offer
                giataId={giataId}
                operatorId={selectedOffer.operator.id}
                offerId={selectedOffer.offer.offerId}
                onGoToListClick={onGoToListClick}
              />
              : <TourOperatorsList
                tourOperators={tourOperators}
                onOfferSelected={onOfferSelected}/>
            }
          </>
        )}
      </div>
    </div>
  )
}

TourOperators.propTypes = {
  giataId: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  relatedItems: PropTypes.array.isRequired,
  propertyImage: PropTypes.string,
}

export default TourOperators
